import React, { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

/**
 * Where the selected period's dates go in the topbar.
 *
 * Figma puts the presets at the left end of the topbar and the dates they
 * resolve to at the right end, next to the theme toggle — with the token
 * meter in between. The time bar is one control that the page injects into
 * the left slot, so the topbar hands it this element and the time bar portals
 * its date range into it. Outside a topbar (tests, a page rendered alone)
 * there is no element and the range simply does not render.
 */
const TopbarPeriodSlotContext = createContext<HTMLElement | null>(null);

export const TopbarPeriodSlotProvider = TopbarPeriodSlotContext.Provider;

export function useTopbarPeriodSlot(): HTMLElement | null {
  return useContext(TopbarPeriodSlotContext);
}

interface TopbarPeriodPortalProps {
  readonly children: React.ReactNode;
}

/** Renders its children in the topbar's period slot, or nowhere without one. */
export const TopbarPeriodPortal: React.FC<TopbarPeriodPortalProps> = ({ children }) => {
  const slot = useTopbarPeriodSlot();
  return slot ? createPortal(children, slot) : null;
};
